const actions = {
  REQUESTING: 'Protocol/REQUESTING',
  RESPONSE_ERROR: 'Protocol/RESPONSE_ERROR',

  FETCH_PROTOCOL_LIST: 'Protocol/FETCH',
  LIST_PROTOCOL: 'Protocol/LIST',
}

export default actions
